import React from 'react';
import ReactModal from 'react-modal';
import Instructions from './Instructions';

const InstructionsModal = ({ isOpen, disableTutorial, onClose }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      className="reveal instructions__reveal full"
      overlayClassName="reveal-overlay reveal-overlay--transparent"
      onRequestClose={onClose}
      appElement={document.getElementById('byo-web-ui')}>
      <Instructions disableTutorial={disableTutorial} onClose={onClose} />
    </ReactModal>
  );
};

export default InstructionsModal;
